import { createSelector } from 'reselect';

const getState = (state) => state.app;

export const getGoogleFonts = createSelector(getState, (state) => state.googleFonts);
